import { useContext, useState } from 'react';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarOutlined } from '@fortawesome/free-regular-svg-icons';
import Input from '../Input';
import { FormContext, FormLabel, IconButton } from '../FormElements';
import './index.scss';

export const StarRating = ({
    id,
    name,
    label,
    disabled,
    formGroupHidden = false,
    formGroupClassName = '',
    labelClassName = '',
    onChange = () => { },
    value = '',
    helperText = '',
    required = false,
    error,
}) => {
    const [hover, setHover] = useState(0);
    const context = useContext(FormContext);

    let fieldValue = value;
    let fieldOnChange = onChange;

    if (context && context.values) {
        fieldValue = context.values[name || id];
        fieldOnChange = (e, v) => {
            onChange(e, v);
            context.onChange(e, v);
        };
    }

    const selectedStar = hover || fieldValue || 0;

    return (
        <div
            className={cls('form-group', formGroupClassName)}
            hidden={formGroupHidden}
        >
            <FormLabel
                htmlFor={id}
                text={label}
                required={required}
                className={labelClassName}
            />

            <div className="star-container">
                {[1, 2, 3, 4, 5].map((star) => (
                    <IconButton
                        key={star}
                        type="button"
                        disabled={disabled}
                        className={cls('star', selectedStar >= star && 'selected')}
                        size="lg"
                        onMouseEnter={() => setHover(star)}
                        onMouseLeave={() => setHover(0)}
                        onClick={(event) => {
                            const newEvent = {
                                ...event || {},
                                target: {
                                    ...event.target || {},
                                    name,
                                    value: star,
                                    type: 'number',
                                },
                            };

                            fieldOnChange(newEvent);
                        }}
                    >
                        <FontAwesomeIcon
                            icon={selectedStar >= star ? faStar : faStarOutlined}
                            className="text-warning"
                        />
                    </IconButton>
                ))}
            </div>

            {Boolean(helperText) && (
                <small className="invalid-feedback helper-text text-muted">
                    {helperText}
                </small>
            )}

            <Input
                name={name}
                hidden
                required={required}
                error={error}
            />
        </div>
    );
};